export const patientPortalRoutes = (apiBase) => ({
  patientPortalCheckDoc: `${apiBase}/portal-paciente/auth/check-document`,
  patientPortalSetPassword: `${apiBase}/portal-paciente/auth/set-password`,
  patientPortalLogin: `${apiBase}/portal-paciente/auth/login`,
  patientPortalResumen: `${apiBase}/portal-paciente/resumen`,
  patientPortalActividades: `${apiBase}/portal-paciente/actividades`,
});

